import React from 'react';
import { string } from 'prop-types';

import ArrowLink from './ArrowLink';

import styles from '../../styles/navigation.module.styl';

const ArrowNavigation = ({ prevLink, nextLink, prevLinkText, nextLinkText }) => {
  return (
    <div className={styles.arrowNavigation}>
      <div className={styles.navigationArrow}>
        <ArrowLink type="left" linkTo={prevLink} linkText={prevLinkText} />
      </div>
      <div className={styles.navigationArrow}>
        <ArrowLink type="right" linkTo={nextLink} linkText={nextLinkText} />
      </div>
    </div>
  );
};

ArrowNavigation.propTypes = {
  prevLink: string,
  nextLink: string,
  prevLinkText: string,
  nextLinkText: string,
};

ArrowNavigation.defaultProps = {
  prevLink: null,
  nextLink: null,
  prevLinkText: 'back',
  nextLinkText: 'next',
};

export default ArrowNavigation;



// WEBPACK FOOTER //
// ./src/components/navigation/ArrowNavigation.js